import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';

const ServiceCtaSection = () => {
  const { t } = useTranslation();
  const { language } = useLanguage();

  return (
    <section className="section" style={{ 
      backgroundColor: 'white',
      position: 'relative',
      overflow: 'hidden',
      padding: '6rem 0'
    }}>
      {/* Decorative elements */}
      <div style={{
        position: 'absolute',
        top: '10%',
        right: '5%',
        width: '300px',
        height: '300px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255, 107, 0, 0.03) 0%, rgba(255, 107, 0, 0) 70%)',
        zIndex: 1
      }}></div>
      
      <div style={{
        position: 'absolute',
        bottom: '5%',
        left: '5%',
        width: '250px',
        height: '250px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255, 107, 0, 0.03) 0%, rgba(255, 107, 0, 0) 70%)',
        zIndex: 1
      }}></div>
      
      <div className="container" style={{ 
        position: 'relative', 
        zIndex: 2, 
        maxWidth: '1200px', 
        margin: '0 auto', 
        padding: '0 1.5rem' 
      }}>
        <div className="cta-card fade-in" style={{
          background: 'linear-gradient(145deg, #FF6B00 0%, #FF9E40 100%)',
          borderRadius: '24px',
          padding: '0',
          color: 'white',
          position: 'relative',
          overflow: 'hidden',
          boxShadow: '0 25px 50px rgba(255, 107, 0, 0.25)'
        }}>
          {/* Top decorative pattern */}
          <div style={{
            position: 'absolute',
            top: '0',
            left: '0',
            right: '0',
            height: '8px',
            background: 'linear-gradient(90deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0) 100%)',
            zIndex: 3
          }}></div>
          
          {/* Decorative shapes */}
          <div style={{
            position: 'absolute',
            top: '-100px',
            right: '-100px',
            width: '300px',
            height: '300px',
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0) 70%)',
            zIndex: 1
          }}></div>
          
          <div style={{
            position: 'absolute',
            bottom: '-80px',
            left: '-50px',
            width: '250px',
            height: '250px',
            borderRadius: '30% 70% 70% 30% / 30% 30% 70% 70%',
            background: 'radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 70%)',
            transform: 'rotate(25deg)',
            zIndex: 1
          }}></div>
          
          <div style={{
            position: 'absolute',
            top: '25%',
            right: '15%',
            width: '60px',
            height: '60px',
            borderRadius: '30% 70% 70% 30% / 30% 30% 70% 70%',
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            transform: 'rotate(25deg)',
            animation: 'float 7s ease-in-out infinite',
            zIndex: 1
          }}></div>
          
          <div style={{
            position: 'absolute',
            bottom: '20%',
            left: '18%',
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            backgroundColor: 'rgba(255, 255, 255, 0.15)',
            animation: 'float 5s ease-in-out infinite',
            animationDelay: '1s',
            zIndex: 1
          }}></div>
          
          <div style={{
            position: 'absolute',
            top: '20%',
            left: '10%',
            width: '20px',
            height: '20px',
            borderRadius: '50%',
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            animation: 'float 4s ease-in-out infinite',
            animationDelay: '2s',
            zIndex: 1
          }}></div>
          
          {/* Pattern background */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            opacity: 0.05,
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23FFFFFF' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            zIndex: 1
          }}></div>
          
          <div style={{ padding: '4rem', position: 'relative', zIndex: 2 }}>
            <span style={{
              display: 'inline-block',
              padding: '0.5rem 1.5rem',
              backgroundColor: 'rgba(255, 255, 255, 0.15)',
              color: 'white',
              borderRadius: '100px',
              fontWeight: '600',
              fontSize: '0.875rem',
              marginBottom: '1.5rem',
              textTransform: 'uppercase',
              letterSpacing: '0.05em'
            }}>
              {language === 'fr' ? 'CONTACTEZ-NOUS' : 
              language === 'ar' ? 'اتصل بنا' : 
              'CONTACT US'}
            </span>
            
            <div className="grid" style={{ 
              display: 'grid',
              gridTemplateColumns: 'repeat(12, 1fr)', 
              gap: '3rem',
              alignItems: 'center'
            }}>
              <div className="col-span-7 md-col-span-12">
                <h2 style={{ 
                  fontSize: '2.75rem',
                  lineHeight: '1.2',
                  marginBottom: '1.5rem',
                  color: 'white',
                  fontWeight: '700',
                  textShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                }}>
                  {language === 'fr' 
                    ? 'Prêt à améliorer vos systèmes d\'instrumentation Pétrole, Gaz et Industrie ?' 
                    : language === 'ar'
                    ? 'هل أنت مستعد لتحسين أنظمة القياس الخاصة بك في قطاع النفط والغاز والصناعة؟'
                    : 'Ready to enhance your Oil, Gas and Industry instrumentation systems?'}
                </h2>
                
                <p style={{ 
                  fontSize: '1.25rem',
                  marginBottom: '2.5rem',
                  color: 'rgba(255, 255, 255, 0.9)',
                  lineHeight: '1.7',
                  maxWidth: '700px',
                  textShadow: '0 1px 2px rgba(0, 0, 0, 0.05)'
                }}>
                  {language === 'fr' 
                    ? 'Contactez-nous dès aujourd\'hui pour discuter de vos besoins spécifiques et découvrir comment notre équipe d\'experts peut vous aider à optimiser vos opérations et à améliorer votre efficacité.' 
                    : language === 'ar'
                    ? 'اتصل بنا اليوم لمناقشة احتياجاتك المحددة واكتشاف كيف يمكن لفريق الخبراء لدينا مساعدتك في تحسين عملياتك وزيادة كفاءتك.'
                    : 'Contact us today to discuss your specific needs and discover how our expert team can help you optimize your operations and improve efficiency.'}
                </p>
                
                <div style={{
                  display: 'flex',
                  gap: '1.5rem',
                  flexWrap: 'wrap'
                }}>
                  <Link 
                    to="/contact" 
                    className="btn btn-white"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '0.75rem',
                      backgroundColor: 'white',
                      color: '#FF6B00',
                      padding: '1rem 2.5rem',
                      borderRadius: '100px',
                      fontWeight: '600',
                      fontSize: '1rem',
                      textDecoration: 'none',
                      transition: 'all 0.3s ease',
                      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                      position: 'relative',
                      overflow: 'hidden'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
                      e.currentTarget.style.transform = 'translateY(-3px)';
                      e.currentTarget.style.boxShadow = '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.backgroundColor = 'white';
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)';
                    }}
                    onClick={(e) => {
                      const ripple = document.createElement('span');
                      ripple.classList.add('ripple');
                      e.currentTarget.appendChild(ripple);
                      
                      const rect = e.currentTarget.getBoundingClientRect();
                      const x = e.clientX - rect.left;
                      const y = e.clientY - rect.top;
                      
                      ripple.style.left = `${x}px`;
                      ripple.style.top = `${y}px`;
                      
                      setTimeout(() => {
                        ripple.remove();
                      }, 600);
                    }}
                  >
                    {language === 'fr' ? 'Demander un devis' : 
                     language === 'ar' ? 'طلب عرض أسعار' : 
                     'Request a quote'}
                    <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '18px', height: '18px' }} viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </Link>
                  
                  <Link 
                    to="/products" 
                    className="btn btn-outline"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '0.75rem',
                      backgroundColor: 'transparent',
                      color: 'white',
                      padding: '1rem 2.5rem',
                      borderRadius: '100px',
                      border: '2px solid rgba(255, 255, 255, 0.7)',
                      fontWeight: '600',
                      fontSize: '1rem',
                      textDecoration: 'none',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                      e.currentTarget.style.transform = 'translateY(-3px)';
                      e.currentTarget.style.borderColor = 'white';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.7)';
                    }}
                  >
                    {language === 'fr' ? 'Voir nos produits' : 
                     language === 'ar' ? 'عرض منتجاتنا' : 
                     'View our products'}
                    <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '18px', height: '18px' }} viewBox="0 0 20 20" fill="currentColor">
                      <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
                      <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
                    </svg>
                  </Link>
                </div>
              </div>
              
              <div className="col-span-5 md-col-span-12 md-hidden" style={{ position: 'relative' }}>
                {/* Service graphic - enhanced 3D version */}
                <div style={{
                  position: 'relative',
                  width: '100%',
                  height: '350px',
                  perspective: '1000px'
                }}>
                  <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%) rotate3d(1, 1, 0, 30deg)',
                    width: '250px',
                    height: '250px',
                    borderRadius: '30px',
                    backgroundColor: 'rgba(255, 255, 255, 0.05)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    boxShadow: '0 25px 50px rgba(0, 0, 0, 0.1), 0 0 40px rgba(255, 255, 255, 0.1) inset',
                    overflow: 'hidden',
                    animation: 'float3d 6s ease-in-out infinite',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    padding: '2rem'
                  }}>
                    {/* Service icon */}
                    <div style={{
                      width: '100px',
                      height: '100px',
                      borderRadius: '30px',
                      backgroundColor: 'rgba(255, 255, 255, 0.15)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '1.5rem',
                      boxShadow: '0 15px 25px rgba(0, 0, 0, 0.1)'
                    }}>
                      <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '50px', height: '50px', color: 'white' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 10V3L4 14h7v7l9-11h-7z" />
                      </svg>
                    </div>
                    
                    <div style={{
                      textAlign: 'center',
                      color: 'white',
                      fontWeight: '600',
                      textShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                    }}>
                      {language === 'fr' ? 'Support technique 24/7' : 
                       language === 'ar' ? 'دعم فني على مدار الساعة' : 
                       '24/7 Technical Support'}
                    </div>
                    
                    {/* Decorative dots */}
                    <div style={{
                      position: 'absolute',
                      top: '15px',
                      left: '15px',
                      width: '12px',
                      height: '12px',
                      borderRadius: '50%',
                      backgroundColor: 'rgba(255, 255, 255, 0.4)',
                    }}></div>
                    
                    <div style={{
                      position: 'absolute',
                      top: '15px',
                      right: '15px',
                      width: '12px',
                      height: '12px',
                      borderRadius: '50%',
                      backgroundColor: 'rgba(255, 255, 255, 0.4)',
                    }}></div>
                    
                    <div style={{
                      position: 'absolute',
                      bottom: '15px',
                      left: '15px',
                      width: '12px',
                      height: '12px',
                      borderRadius: '50%',
                      backgroundColor: 'rgba(255, 255, 255, 0.4)',
                    }}></div>
                    
                    <div style={{
                      position: 'absolute',
                      bottom: '15px',
                      right: '15px',
                      width: '12px',
                      height: '12px',
                      borderRadius: '50%',
                      backgroundColor: 'rgba(255, 255, 255, 0.4)',
                    }}></div>
                  </div>
                  
                  {/* Background floating elements */}
                  <div style={{
                    position: 'absolute',
                    top: '10%',
                    right: '10%',
                    width: '80px',
                    height: '80px',
                    borderRadius: '24px',
                    border: '2px solid rgba(255, 255, 255, 0.1)',
                    transform: 'rotate(15deg)',
                    animation: 'float 8s ease-in-out infinite',
                    animationDelay: '1s'
                  }}></div>
                  
                  <div style={{
                    position: 'absolute',
                    bottom: '15%',
                    left: '15%',
                    width: '40px',
                    height: '40px',
                    borderRadius: '12px',
                    border: '2px solid rgba(255, 255, 255, 0.1)',
                    transform: 'rotate(45deg)',
                    animation: 'float 6s ease-in-out infinite',
                    animationDelay: '2s'
                  }}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <style jsx>{`
        .ripple {
          position: absolute;
          border-radius: 50%;
          background-color: rgba(255, 255, 255, 0.4);
          transform: scale(0);
          animation: ripple 0.8s linear;
        }
        
        @keyframes ripple {
          to {
            transform: scale(4);
            opacity: 0;
          }
        }
        
        @media (max-width: 768px) {
          .md-hidden {
            display: none;
          }
          
          .md-col-span-12 {
            grid-column: span 12;
          }
        }
      `}</style>
    </section>
  );
};

export default ServiceCtaSection;